import TextFormFieldModal from '../../components/organisms/TextFormFieldModal/TextFormFieldModal';
import { ModalTypes } from '../../enums/modalTypes';
import CandidateEditInfoFieldModal from './CandidateInfoFieldModal/CandidateInfoFieldModal';
import StaticContentFiltersModal from './StaticContentFiltersModal/StaticContentFiltersModal';
import AddTraitModal from './TraitModals/AddTraitModal/AddTraitModal';
import EditTraitModal from './TraitModals/EditSoftSkillModal/EditTraitModal';

export const renderModalObject = {
  [ModalTypes.CANDIDATE_INFO_FIELD_MODAL]: CandidateEditInfoFieldModal,
  [ModalTypes.TEXT_FIELD_MODAL]: TextFormFieldModal,
  [ModalTypes.ADD_TRAIT_MODAL]: AddTraitModal,
  [ModalTypes.EDIT_TRAIT_MODAL]: EditTraitModal,
  [ModalTypes.STATIC_CONTENT_FILTERS_MODAL]: StaticContentFiltersModal,
};
